module.exports = __webpack_public_path__ + "lc.svg?5b5cf66fa539a46a80ee844a1bdfa81f";